module.exports = __webpack_public_path__ + "static/img/janczaki-logo.51e04ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-logos/janczaki-logo.svg
// module id = LBcr
// module chunks = 0